import React, { createContext } from 'react';
import { v4 as uuidv4 } from 'uuid';

export const SettingsContext = createContext({
    'appUrl': '',
    'formListEndpoint': '',
    'fhirClientId': '',
    'practitionerLauncherEndpoint': '',
    'practitionerLauncherScope': '',
    'patientLauncherEndpoint': '',
    'patientLauncherScope': '',
    'fhirEndpoint': '',
    'environmentDropdown': '',
    'environmentDefault': '',
    'apiSubscriptionKey': '',
    'isDev': true,
    'devBannerText': 'Entry of patient data is prohibited at this time. Please use test data only.',
    'siteName': 'DEV',
    'submissionRedirectUrl': '',
    'practitionerIdentifierKey': '',
    'fhirPathResources': [],
    'features': {
        'enableDebugger': false,
        'enableNavigation': true,
        'enableDraft': true,
        'enableDraftSharing': false,
        'enableDownloadPdf': true,
        'enableAutoDownloadPdf': true,
        'enableSubmitPdf': true
    }
});

export class SettingsProvider extends React.Component {
    state = {
        isLoaded: false
    };

    componentDidMount() {
        this.getSettings();
    }

    getSettings = () => {
        fetch(`/settings.json?rev=${uuidv4()}`).then((response) => {
            return response.json();
        }).then((json) => {
            this.setState({
                isLoaded: true,
                ...json
            });

            document.getElementsByTagName('title')[0].text = json.siteName;
        });
    }

    render() {
        return (
            <SettingsContext.Provider value={this.state}>
                {
                    this.state.isLoaded ?
                        this.props.children
                        : null
                }
            </SettingsContext.Provider>
        );
    }
}

export const SettingsConsumer = SettingsContext.Consumer;
